import { render, staticRenderFns } from "./MobileNavigation.vue?vue&type=template&id=33d1fe9e&"
import script from "./MobileNavigation.vue?vue&type=script&lang=js&"
export * from "./MobileNavigation.vue?vue&type=script&lang=js&"
import style0 from "./MobileNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
installComponents(component, {VBottomNavigation})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33d1fe9e')) {
      api.createRecord('33d1fe9e', component.options)
    } else {
      api.reload('33d1fe9e', component.options)
    }
    module.hot.accept("./MobileNavigation.vue?vue&type=template&id=33d1fe9e&", function () {
      api.rerender('33d1fe9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/navigation/MobileNavigation.vue"
export default component.exports